import { useState } from "react";
import "@/App.css";

// Components
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import SocialProof from "@/components/SocialProof";
import Experiences from "@/components/Experiences";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminDashboard from "@/components/AdminDashboard";

function App() {
  const [showAdmin, setShowAdmin] = useState(false);

  if (showAdmin) {
    return <AdminDashboard onClose={() => setShowAdmin(false)} />;
  }

  return (
    <div className="min-h-screen bg-cream">
      <Navigation />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <SocialProof />
        <Experiences />
        <About />
        <Contact />
      </main>
      <Footer onAdminClick={() => setShowAdmin(true)} />
    </div>
  );
}

export default App;
